/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 14:08:51
 * @Description:  头部注释
 */
import React, { Component } from "react";
import { SelectValue } from "antd/lib/select";
import {Select,Spin} from "antd";
import AppService from "../service/app.service";
import "./style.css";
const { Option } = Select;
interface LabeledValue {
  label: string;
  key: string;
}
interface iProps {
  value?: any;
  allowClear?: boolean;
  placeholder?: string;
  url?: string;
  userType?: string;
  onChange?: (value: any) => void;
  params?:any;
}
interface iState {
  options: any[];
  fetching: boolean;
}
export default class UserSingleSelect extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    options: [],
    fetching: false,
  };
  search = async (searchText = "", outparams = null) => {
    let { url = "", userType = "TEACHER,STUDENT", params = {} } = this.props;
    let options = await this.appService.searchPersons({
      url,
      searchText,
      userType,
      params: outparams || params
    });
    this.setState({ options, fetching: false });
  };
  get value() {
    let { value = null } = this.props;
    // if (!value) return {};
    return {
      value: value?.userId??'',
      label: value?.fullname??'',
      key: value?JSON.stringify(value):'',
    };
  }
  componentDidMount() {
    this.search();
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.params &&  this.props.params && (JSON.stringify(this.props.params) !== JSON.stringify(nextProps.params))) {
      this.search('', nextProps.params)
    }
  }
  handleChange = async (selectedItem) => {
    console.log(selectedItem)
    this.props.onChange(selectedItem?JSON.parse(selectedItem.key):'');
    if (!selectedItem) {
      this.search();
    }
  };
  handleSearch = async (searchText) => {
    await this.setState({ fetching: true });
    this.search(searchText);
  };
  // handleBlur = () => {
  //   this.search();
  // };
  render() {
    const { placeholder = "请选择", allowClear = true } = this.props;
    const { fetching, options } = this.state;
    const filteredOptions = options.filter((o) => this.value.value != o.userId);
    return (
      <Select
        showSearch
        labelInValue={true}
        value={this.value}
        allowClear={allowClear}
        onSearch={this.handleSearch}
        // onBlur={this.handleBlur}
        dropdownClassName="user-select"
        placeholder={placeholder}
        dropdownMatchSelectWidth={false}
        filterOption={false}
        onChange={this.handleChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: "100%" }}
      >
        {filteredOptions.map((item: any) => (
          <Option label={item.fullname} key={JSON.stringify(item)}>
            {/* <MyIcon type={`icon${item.userType.toLowerCase()}`} /> */}
            {item.fullname}（{item.no}）
          </Option>
        ))}
      </Select>
    );
  }
}
